import { Component, OnDestroy, OnInit } from '@angular/core';
import { DisputeTrackerService } from '../dispute-tracker.service';
import { Subscription } from 'rxjs';
import { ConsumerDispute } from '../models/consumerDispute';
import { tap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { FilteringService } from 'src/app/services/filtering.service';
import { Router } from '@angular/router';
import { NgbModal, NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { DisputeModalComponent } from '../dispute-modal/dispute-modal.component';

@Component({
  selector: 'app-dispute-list',
  templateUrl: './dispute-list.component.html',
  styleUrls: ['./dispute-list.component.less']
})
export class DisputeListComponent implements OnInit, OnDestroy {

  def: NgbNav;
  activeId : number;

  $dispoFetchSub: Subscription;
  private _dispoModels: ConsumerDispute[] = [];

  //unresolved
  public get unresolvedData(): ConsumerDispute[] {
    if(!this._dispoModels) return [];
    else return this._dispoModels.filter(m => !m.isResolved)
  }

  public get resolvedData(): ConsumerDispute[] {
    if(!this._dispoModels) return [];
    else return this._dispoModels.filter(m => m.isResolved)
  }

  constructor(private disputeService: DisputeTrackerService, private toast: ToastrService, 
    public filtering: FilteringService, public router: Router, private modalService: NgbModal) {
        
  }
  ngOnDestroy(): void {
    if(this.$dispoFetchSub) this.$dispoFetchSub.unsubscribe();
  }
  ngOnInit(): void {
    this.$dispoFetchSub = this.disputeService.getAllConsumerDisputes().pipe(
      tap((_: ConsumerDispute[]) => {
        this._dispoModels = _;
      },
      err => {
        this.toast.error('Error fetching consumer disputes list!', '', { closeButton: true, disableTimeOut: true })
      },
      () => {

      })
    ).subscribe();
  }

  public openDisputeDialog(dispo: ConsumerDispute) {
    const mod = this.modalService.open(DisputeModalComponent, { size: 'xl' });
    mod.componentInstance.existingDispute = dispo;
  }

  public navTo(dispo: ConsumerDispute) : void {
    this.router.navigateByUrl(`screenings/review/${dispo.screeningId}`);
  }

  public reactivateDispute(dispo: ConsumerDispute): void {
    if (!dispo.isResolved) {
      this.toast.warning('This dispute is already active.');
      return;
    }

    this.disputeService.reactivateConsumerDispute(dispo.id).subscribe(
      () => {
        this.toast.success(`Dispute for Report #${dispo.reportNumber} has been reactivated.`);
        dispo.isResolved = false;
        dispo.dateResolved = null;
        dispo.resolutionNote = null;
        dispo.resolvingUserName = null;
      },
      (error) => {
        this.toast.error('Error reactivating dispute', '', { closeButton: true, disableTimeOut: true });
      }
    );
  }

}
